<mat-list>
    <mat-list-item class="upload-item" *ngFor="let file of files; let i = index;">
        <mat-icon mat-list-icon>file_copy</mat-icon>
        <span mat-line class="filename">
            {{ file.file.name }}
        </span>
        <div mat-line class="progress">
            <app-upload-progress [file]="file"></app-upload-progress>
        </div>
        <button mat-icon-button color="accent" type="button"
            *ngIf="file.status === uploadStatus.waiting || file.status === uploadStatus.fail"
            (click)="onRemoveFile(i)">
            <mat-icon aria-label="Cancel button">cancel</mat-icon>
        </button>
    </mat-list-item>
</mat-list>
